export default function ScrollIndicator() {
  return (
    <div className="flex flex-col items-center gap-2 animate-pulse">
      <span className="text-xs tracking-widest uppercase text-warm-stone">Scroll</span>
      <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        className="text-warm-stone"
      >
        <rect x="1" y="1" width="14" height="22" rx="7" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="8" cy="8" r="2" fill="currentColor">
          <animate
            attributeName="cy"
            values="8;16;8"
            dur="2s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  );
}
